import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { inOutAnimation } from '@app/shared/utils';
import { IVisitReviewReplyForm } from '@app/visit-reviews/models';

@Component({
  selector: 'app-visit-review-reply-form',
  templateUrl: './visit-review-reply-form.component.html',
  styleUrls: ['./visit-review-reply-form.component.scss'],
  animations: [inOutAnimation]
})
export class VisitReviewReplyFormComponent{
  @Input() visitReviewReplyFormData: IVisitReviewReplyForm;
  @Output() formSubmitted = new EventEmitter<void>();

  readonly replyTextLimit = 500;

  onFormSubmit(form: NgForm): void {
    if (form.valid) {
      this.formSubmitted.next();
    }
  }
}
